import { Component, OnInit, Directive } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as firebase from 'firebase/app';
import 'firebase/storage';
import { ActivatedRoute, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthService } from '../../../services/auth/auth.service';
import { WindowService } from '../../../services/window/window.service';
import { FormsModule, FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
//import { FormControl } from '@angular/forms/src/model';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection, docChanges } from 'angularfire2/firestore';
import { Observable, Subject } from 'rxjs/Rx';
import { User } from '../../datamodel/user';
import { ToggleService } from '../../../services/toggle/toggle.service';
import { StateService } from '../../../services/state/state.service';
import { MatDatepicker } from '@angular/material';
import * as _ from 'underscore';
import { forEach } from '@angular/router/src/utils/collection';
import { Ng4LoadingSpinnerModule, Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as $ from 'jquery';

interface Shift {
	type: any;
}
interface ProviderShift {
	type: any;
}
const httpOptions = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json',
		'Authorization': 'key=AIzaSyBDB_jgKH-eDllQnGWTQJiRmQ2vSS0hKag'
	})
};
function mapSnapshot(changes: any) {
	return changes.map(a => {
		const data = a.payload.doc.data() as User;
		const id = a.payload.doc.id;
		return { id, ...data };
	});
}

@Component({
	moduleId: module.id,
	selector: 'app-add-schedule',
	templateUrl: './add-schedule.component.html',
	styleUrls: ['./add-schedule.component.scss'],
	providers: [WindowService]
})
export class AddScheduleComponent implements OnInit {
	public addShiftForm: FormGroup;
	tab = 1;
	setTab(newTab) {
		this.tab = newTab;
	};
	isSet = function (tabNum) {
		return this.tab === tabNum;
	};
	
	public tagsList = ['Car', 'Bus', 'Train'];
	public autocompleteTags = [];
	public autocompleteItems = [];
	public selRow = 0;
	public weekList:Array<any>;
	public selectedDoctors = [];
	public selectedDays = [];
	public weekDays = [];
	public activeDays = [];
	
	public listDepartments = [];
	public listDoctors = [];
	public user: User;
	public userProfile: object;
	private userRef: AngularFirestoreCollection<User>;
	obsUser: Observable<any>;
	
	public objSchedule: any;
	private scheduleRef: AngularFirestoreCollection<any>;
	obsSchedule: Observable<any>;

	private shiftRef: AngularFirestoreCollection<any>;
	obsShift: Observable<any>;
	isFormSubmit: boolean = false;

	public minDate = new Date();

	doctorsListHTML: string;

	constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth, public auth: AuthService, private win: WindowService, private fb: FormBuilder, public toggle: ToggleService, private state: StateService, private router: Router, public route: ActivatedRoute, public http: HttpClient, private spinnerService: Ng4LoadingSpinnerService) {
		for(let d in [0,1,2,3,4,5,6,7,8,9,10,11,12,13]){
			var d1 = parseInt(d);
			this.selectedDoctors[d] = { "enable":false, "id":"", "name":"", "photo":"" };
			this.selectedDays[d] = {"enable": false};
			if(d1 > 6){
				d1 = d1%7;
				this.weekDays[d1] = d1;
				this.activeDays[d1] = { "enable": false };
			}else{
				this.weekDays[d] = d;
				this.activeDays[d] = { "enable": false };
			}
		}
	}

	dateFormat(dt){
		dt = new Date(dt);
		let dfm = [
			dt.getFullYear(),
			('0' + (dt.getMonth() + 1)).slice(-2),
			('0' + dt.getDate()).slice(-2)
		].join('-');
		return dfm;
	}

	goSchedulesList() {
		this.router.navigate(['/schedules']);
	}

	goBack() {
		this.tab = 1;
	}

	getDepartmentList(){
		//create list of all the departments
		const departmentRef = this.afs.collection('departments', ref => ref.orderBy('name'));
		departmentRef.snapshotChanges().map(mapSnapshot).subscribe(departments => {
			this.listDepartments = departments;
		});
	}

	getDoctorsList(){
		let objUser = firebase.auth().currentUser;
		const userRef = this.afs.collection('users').doc(objUser.uid);
		userRef.valueChanges().subscribe(user => {
			//Get user hospital
			const hospId = (user['adminFor'] && user['adminFor'].length > 0 && user['adminFor'][0].id)
				? user['adminFor'][0].id : '';
				
			const doctorsRef = this.afs.collection('providers', ref => ref.where('credentialedAt.' + hospId + '.id', '==', hospId));
			doctorsRef.snapshotChanges().map(mapSnapshot).subscribe(docs => {
				this.listDoctors = docs;
			});
		});
	}

	range(key, count){
		var arr = [];
		for(let i=0;i<count;i++){
			arr.push(i);
		}
		return arr;
	}

	isFieldValid(field) {
		return !this.addShiftForm.get(field).valid && (this.addShiftForm.get(field).dirty || this.addShiftForm.get(field).touched);
	}

	isShiftFieldValid(field) {
		return !field.valid && (field.dirty || field.touched);
	}

	selectDay(d){
		var j = parseInt(d);
		if (j > 6) {
			j = j % 7;
		}
		if (!this.selectedDays[d].enable){
			this.selectedDays[d] = { "enable": true, "doc_type": "MD/DO", "department": "", "shift_type": "full_time", "provider_id": "1" };
			this.activeDays[j] = { "enable": true };
		}else{
			this.selectedDays[d] = { "enable": false };
			this.activeDays[j] = { "enable": false };
		}
	}

	validateStep1() {
		let self = this;
		let objSchedule = this.addShiftForm.value;
		if (objSchedule.name == "") {
			this.isFieldValid('name');
		}
		let objShift = objSchedule.shifts;
		let objDays = this.selectedDays;
		let objSelectedDoctors = this.selectedDoctors;
		let currdate = new Date();
		let shiftObj = [];
		for (let j in objDays) {
			var d = parseInt(j);
			if (d > 6) {
				d = parseInt(j) % 7;
			}
			if(objDays[j].enable){
				shiftObj[j] = { "enable": true, "doc_type": objShift[d].doc_type, "department": objShift[d].department, "shift_type": objShift[d].shift_type, "provider_id": objShift[d].provider_id };
				shiftObj[j].providers = {};
			}
		}
		console.log(shiftObj);
		let error = "";
		if (objSchedule.name == "") {
			error += "<li>Schedule name is required</li>";
			this.isFieldValid('name');
		}
		
		this.addShiftForm.patchValue({
			name: objSchedule.name,
			start_date: objSchedule.start_date,
			end_date: objSchedule.end_date,
			shifts: shiftObj
		});
		//error = "";
		if (error == "") {
			let objUser = firebase.auth().currentUser;
			const userRef = this.afs.collection('users').doc(objUser.uid);
			userRef.valueChanges().subscribe(user => {
				//Get user hospital
				const hospId = (user['adminFor'] && user['adminFor'].length > 0 && user['adminFor'][0].id)
					? user['adminFor'][0].id : '';
				const hospDoc = this.afs.doc('institutions/' + hospId);
				return self.afs.collection('schedules').add({
					name: objSchedule.name,
					tags: objSchedule.tags,
					start_date: objSchedule.start_date,
					end_date: objSchedule.end_date,
					instituteRef: {
						id: hospId,
						ref: hospDoc.ref
					},
					//shifts: objSft,
					created: new Date()
				});

			});
		} else {

		}
	}

	assignDoctor(doc) {
		var d = this.selRow;
		var d1 = this.selRow;
		if (d > 6) {
			d1 = d % 7;
		}
		alert(d+"-----"+d1);
		if (this.selectedDays[d].enable) {
			this.selectedDoctors[d] = {};
			this.selectedDoctors[d].id = doc.id;
			this.selectedDoctors[d].name = doc.first_name + " " + doc.last_name;
			if (doc.photo && doc.photo !== "") {
				this.selectedDoctors[d].photo = doc.photo;
			} else {
				this.selectedDoctors[d].photo = "../assets/img/1.png";
			}
			alert(doc.first_name + " " + doc.last_name);
			if (this.selectedDays[d1].enable) {
				this.selectedDoctors[d1] = {};
				this.selectedDoctors[d1].id = doc.id;
				this.selectedDoctors[d1].name = doc.first_name + " " + doc.last_name;
				if (doc.photo && doc.photo !== "") {
					this.selectedDoctors[d1].photo = doc.photo;
				} else {
					this.selectedDoctors[d1].photo = "../assets/img/1.png";
				}
				alert(doc.first_name + " " + doc.last_name);
			}
			$(".btn-group").removeClass('open');
		} else if (this.selectedDays[d1].enable) {
			this.selectedDoctors[d1] = {};
			this.selectedDoctors[d1].id = doc.id;
			this.selectedDoctors[d1].name = doc.first_name + " " + doc.last_name;
			if (doc.photo && doc.photo !== "") {
				this.selectedDoctors[d1].photo = doc.photo;
			} else {
				this.selectedDoctors[d1].photo = "../assets/img/1.png";
			}
			alert(doc.first_name + " " + doc.last_name);
		}
	}

	removeDoctor(l){
		this.selectedDoctors[l] = { "id": "", "name": "", "photo": ""};
	}

	initShift() {
		// initialize our address
		return this.fb.group({
			doc_type: new FormControl('', Validators.required),
			department: new FormControl(''),
			shift_type: new FormControl('', Validators.required),
			provider_id: new FormControl('')
		});
	}

	ngOnInit() {
		this.addShiftForm = this.fb.group({
			name: ['', Validators.required],
			tags: [[]],
			start_date: ['', Validators.required],
			end_date: ['', Validators.required],
			shifts: this.fb.array([
				this.initShift(),
				this.initShift(),
				this.initShift(),
				this.initShift(),
				this.initShift(),
				this.initShift(),
				this.initShift()
			])
		});

		this.weekList = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		this.getDepartmentList();
		this.getDoctorsList();
		var sobj = [];
		for (let i in [0, 1, 2, 3, 4, 5, 6]) {
			sobj[i] = {};
			sobj[i].doc_type = 'MD/DO';
			sobj[i].department = '';
			sobj[i].shift_type = 'full_time';
			sobj[i].provider_id = '';
		}
		let now = new Date();
		var d = new Date();
		d.setMonth(d.getMonth() + 12);
		this.addShiftForm.patchValue({
			start_date: new Date(),
			end_date: d,
			shifts: sobj
		});
	}

	sendPush(hospId, providerId, sdlId, sftId) {
		let self = this;
		var hospRef = this.afs.doc('institutions/' + hospId);
		var providerRef = this.afs.doc('providers/' + providerId);
		var scheduleRef = this.afs.doc('schedules/' + sdlId);
		//var shiftRef = this.afs.doc('schedules_shifts/' + sftId);
		const document: AngularFirestoreDocument<any> = this.afs.doc('providers/' + providerId);
		const document$: Observable<any> = document.valueChanges();
		document$.subscribe(providers => {
			var nTitle = "Shift assign";
			const idocument: AngularFirestoreDocument<any> = this.afs.doc('institutions/' + hospId);
			const idocument$: Observable<any> = idocument.valueChanges();
			idocument$.subscribe(hspdata => {
				console.log(providers);
				var nMessage = hspdata.name + " has created a new schedule and assigned shift to you.";
				if (providers.device && providers.device.deviceToken) {
					let message = {
						"notification": {
							"title": nTitle,
							"body": nMessage,
							"sound": "default",
							"click_action": "FCM_PLUGIN_ACTIVITY",
							"icon": "fcm_push_icon"
						},
						"data": {
							"param1": "value1",
							"param2": "value2"
						},
						"to": providers.device.deviceToken,
						"priority": "high",
						"restricted_package_name": ""
					};
					console.log(message);
					this.http
						.post('https://fcm.googleapis.com/fcm/send', message, httpOptions)
						.subscribe(data => {
							console.log(data);
							//add notification collection
							self.afs.collection('notifications').add({
								created_at: new Date(),
								institute: {
									id: hospId,
									ref: hospRef.ref
								},
								provider: {},
								type: 'assign_shift',
								schedule: {
									id: sdlId,
									ref: scheduleRef.ref
								},
								recipient: {
									id: providerId,
									ref: providerRef.ref
								},
								message: { body: nMessage, title: nTitle},
								status: true
							});
						});
				}
			});
		});
	}

	CalculateWeekendDays(fromDate, toDate, weekDayKey) {
		if (weekDayKey > 6) {
			weekDayKey = weekDayKey % 7;
		}
		var start = new Date(fromDate);
		var finish = new Date(toDate);
		var dayMilliseconds = 1000 * 60 * 60 * 24;
		var weekendDays = 0;
		while (start.getTime() <= finish.getTime()) {
			var day = start.getDay();
			if (day == weekDayKey) {
				weekendDays++;
			}
			start = new Date(+start + dayMilliseconds);
		}
		return weekendDays;
	}

	submit() {
		let self = this;
		let objSchedule = this.addShiftForm.value;
		var shiftsObj = objSchedule.shifts;
		var objDays = this.selectedDays;
		console.log(shiftsObj);
		var currdate = new Date();
		if (self.addShiftForm.valid) {
			self.spinnerService.show();
			let objUser = firebase.auth().currentUser;
			const userRef = this.afs.collection('users').doc(objUser.uid);
			userRef.valueChanges().subscribe(user => {
				//Get user hospital
				const hospId = (user['adminFor'] && user['adminFor'].length > 0 && user['adminFor'][0].id)
					? user['adminFor'][0].id : '';
			
				this.prepairShiftData(shiftsObj, objDays).then((shiftObjData) => {
					console.log(shiftObjData);
					self.createSchedule(hospId, objSchedule)
					.then((newScheduleRef) => {
						console.log(newScheduleRef);
						self.createShifts(newScheduleRef, objSchedule, shiftObjData, objDays)
						.then((sfres) => {
							console.log(sfres);
							var cnt = 0;
							var slength = shiftsObj.length;
							var objDoctors = [];
							for (let k in sfres) {
								var pvdId = '';
								if (sfres[k].pobjt && sfres[k].pobjt !== "" && sfres[k].pobjt !== "undefined") {
									pvdId = sfres[k].pobjt;
								}
								self.createProviderSchedules(hospId, sfres[k].sdlid, sfres[k].sflid, sfres[k].day, sfres[k].stdate, sfres[k].endate, pvdId)
								.then((res2) => {
									cnt++;
									if (sfres[k].pobjt!=="") {
										console.log(sfres[k].pobjt);
										
										if (objDoctors.indexOf(sfres[k].pobjt) >= 0){

										}else{
											objDoctors.push(sfres[k].pobjt);
											this.sendPush(hospId, sfres[k].pobjt, sfres[k].sdlid, sfres[k].sflid);
										}
									}
								});

							}
							self.spinnerService.hide();
							self.router.navigate(['/schedules']);
						})
					})
					.catch((err) => {
						self.spinnerService.hide();
						console.log(err);
					});
				});
			});
		}
	}

	prepairShiftData(objShift, objDays) {
		var shiftObj = [];
		var cntSift = 0;
		var shiftObj = [];

		return new Promise(function (resolve, reject) {
			for (let j in objShift) {
				//shiftObj[j] = objShift[j];
				for (let j in objDays) {
					var d = parseInt(j);
					if (d > 6) {
						d = parseInt(j) % 7;
					}
					if (objDays[j].enable) {
						shiftObj[j] = { "enable": true, "doc_type": objShift[d].doc_type, "department": objShift[d].department, "shift_type": objShift[d].shift_type, "provider_id": objShift[d].provider_id };
					}
				}
				cntSift++;
				if (cntSift == objShift.length) {
					resolve(shiftObj)
				}
			}
		});
	}

	createSchedule(hospId, objSchedule){
		console.log(objSchedule);
		var objSelectedDoctors = this.selectedDoctors;
		var currdate = new Date();
		const hospDoc = this.afs.doc('institutions/' + hospId);
		//create collection of this user
		var self = this;


		return this.afs.collection('schedules').add({
			name: objSchedule.name,
			tags: objSchedule.tags,
			start_date: objSchedule.start_date,
			end_date: objSchedule.end_date,
			instituteRef: {
				id: hospId,
				ref: hospDoc.ref
			},
			//shifts: objSft,
			created: new Date()
		});
	}

	createShifts(newScheduleRef, objSchedule, objShift, objDays){
		console.log(objShift)
		var self = this;
		return new Promise(function (resolve, reject) {
			const sdlReference = self.afs.doc('schedules/' + newScheduleRef.id);
			let promiseArr = [];
			var tempR = [];
			for (let i in objShift) {
				if (objShift[i].provider_id !== "") {
					const providerDoc = self.afs.doc('providers/' + objShift[i].provider_id);
					let _promise = self.afs.collection('schedules_shifts').add({
						scheduleRef: {
							id: newScheduleRef.id,
							ref: sdlReference.ref
						},
						day: parseInt(i),
						doc_type: objShift[i].doc_type,
						department: objShift[i].department,
						shift_type: objShift[i].shift_type,
						total_docs: '1',
						provider: {
							id: objShift[i].provider_id,
							ref: providerDoc.ref
						},
						created: new Date()
					}).then(function (res) {
						tempR.push({ sdlid: newScheduleRef.id, sflid: res.id, day: i, stdate: objSchedule.start_date, endate: objSchedule.end_date, pobjt: objShift[i].provider_id });
					}).catch(err =>{
						
					});
					promiseArr.push(_promise);
				} else {
					let _promise = self.afs.collection('schedules_shifts').add({
						scheduleRef: {
							id: newScheduleRef.id,
							ref: sdlReference.ref
						},
						day: parseInt(i),
						doc_type: objShift[i].doc_type,
						department: objShift[i].department,
						shift_type: objShift[i].shift_type,
						total_docs: '1',
						provider: {
							id: '',
							ref: ''
						},
						created: new Date()
					}).then(function (res){
						//create notifications to providers
						//resolve(res);
						tempR.push({ sdlid: newScheduleRef.id, sflid: res.id, day: i, stdate: objSchedule.start_date, endate: objSchedule.end_date, pobjt: objShift[i].provider_id });
					}).catch(err =>{
						
					});
					
					promiseArr.push(_promise);
				}
			}

			return Promise.all(promiseArr).then(data => {
				data.forEach((da, i) => {
					//tempR[i].sflid = da['id'];
					console.log('da............');
					console.log(da);
				});
				resolve(tempR);
			})
			.catch(err => reject(err));
		});	


		/*.then((res) => {
			tempR.push({ sdlid: newScheduleRef.id, sflid: res.id, day: i, stdate: objSchedule.start_date, endate: objSchedule.end_date, pobjt: objShift[i].provider_id });
			if (tempR.length == objDays.length) resolve(tempR);
		});

		return new Promise(function (resolve, reject) {
			
		});
		*/
	}

	createProviderSchedules(hospId, sdlId, sftId, wday, stdate, endate, docId) {
		console.log(hospId);
		var self = this;
		const hospDoc = self.afs.doc('institutions/' + hospId);
		//const docRef = self.afs.doc('providers/' + docId);
		var shiftReference = self.afs.doc('schedules_shifts/' + sftId);
		var sdlReference = self.afs.doc('schedules/' + sdlId);

		var tempR2 = 0;
		return new Promise(function (resolve, reject) {
			var providerRef: any;
			if (docId && docId !== '') {
				providerRef = self.afs.doc('providers/' + docId).ref;
			}else{
				providerRef = '';
			}

			var startDate = new Date(stdate);
			let orginalStartDate = new Date(stdate).getTime();
			let endDate = new Date(endate);
			let dayCount = self.CalculateWeekendDays(startDate, endDate, wday);
			var day2 = wday % 7;
			if (wday > 6) {
				var sday = (wday) - (startDate.getDay() || day2);
				var loopStartDate = new Date(startDate.getTime() + sday * 86400000);
			}
			else {
				var sday = (day2) - (startDate.getDay() || day2);
				var loopStartDate = new Date(startDate.getTime() + sday * 86400000);
			}

			var dLimit = Math.floor(dayCount / 2);

			for (let j = 0; j < dLimit; j++) {
				if (j > 0) {
					loopStartDate.setDate(loopStartDate.getDate() + 14);
				}
				else {
					loopStartDate.setDate(loopStartDate.getDate());
				}

				if (loopStartDate.getTime() >= orginalStartDate && loopStartDate.getDay() == day2) {
					self.afs.collection('provider_schedules').add({
						instituteRef: {
							id: hospId,
							ref: hospDoc.ref
						},
						schedule: {
							id: sdlId,
							ref: sdlReference.ref
						},
						shift: {
							id: sftId,
							ref: shiftReference.ref
						},
						provider: {
							id: docId,
							ref: providerRef
						},
						shift_date: loopStartDate,
						shift_date_format: self.dateFormat(loopStartDate),
						shift_timestamp: loopStartDate.getTime(),
						day: loopStartDate.getDay(),
						created: new Date()
					});
				}
			}
			tempR2++;
			resolve(tempR2);
			// } else {
			// 	resolve(tempR2);
			// }
		});
	}
	
}



// WEBPACK FOOTER //
// ./src/app/modules/schedules/add-schedule/add-schedule.component.ts